import CompressSub from './src/compressSub';
CompressSub.install=function(Vue,ops){
  Vue.component(CompressSub.name,CompressSub);
}
export default CompressSub;



// WEBPACK FOOTER //
// ./src/packages/compressSub/index.js